export var PreventionCourseState;
(function (PreventionCourseState) {
    PreventionCourseState["NEW"] = "NEW";
    PreventionCourseState["IN_PROGRESS"] = "IN_PROGRESS";
    PreventionCourseState["COMPLETED"] = "COMPLETED";
})(PreventionCourseState || (PreventionCourseState = {}));
//# sourceMappingURL=prevention-course-module-state.js.map